import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import styled from "styled-components";
import { CARBON_RATIO_STATUS } from "../../constants/CarbonRatioStatus";

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.16);
  overflow-x: auto;
`;

export const ListHeader = styled.div`
  min-width: 100%;
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid  rgba(0, 0, 0, 0.87);
  background: #FAFAFA;
`;

export const HeaderContent = styled.div`
  width: 140px;
  display: flex;
  padding: 16px;
  align-items: center;
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledArrowDown = styled(ArrowDownward)`
  display: flex;
  padding: 0px 4px;
  align-items: flex-start;
  gap: 10px;
`;

export const StyledArrowUp = styled(ArrowUpward)`
  display: flex;
  padding: 0px 4px;
  align-items: flex-start;
  gap: 10px;
`;

export const ListContent = styled.div`
  min-width: 100%;
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(0, 0, 0, 0.12);
`;

export const CellContentCte = styled.div`
  width: 140px;
  display: flex;
  flex-direction: column;
  padding: 6px 16px;
`;

export const FirstTextCte = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CellText = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CellContent = styled.div`
  width: 140px;
  max-height: 55px;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CellContentCarbonRatioStatus = styled.div`
  width: 140px;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  border-radius: 100px;
  color: #fff;

  background-color: ${props => {
    switch (props.carbonRatioStatus) {
      case CARBON_RATIO_STATUS.BAD:
        return '#D32F2F';
      case CARBON_RATIO_STATUS.NORMAL:
        return '#FFB200';
      case CARBON_RATIO_STATUS.GOOD:
        return '#2E7D32';
      default:
        return '#2E7D32';
    }
  }};
`;
